import { render, staticRenderFns } from "./VehicleDetailRightSidebar.vue?vue&type=template&id=5a98d915&scoped=true&"
import script from "./VehicleDetailRightSidebar.vue?vue&type=script&lang=ts&"
export * from "./VehicleDetailRightSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleDetailRightSidebar.vue?vue&type=style&index=0&id=5a98d915&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a98d915",
  null
  
)

export default component.exports